<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="700"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider v-if="form.parent_id !== '' && form.parent_id !== '0'"
                    name="Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div 
                      class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Unit
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      readonly

                      :color="set_color"
                      placeholder="Contoh. Kantor Pusat PT SDM"

                      hide-details
                      
                      :items="unit"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.parent_id"
                      :success="form.parent_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.parent_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Nama Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div 
                      class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Unit
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Kontraktor"

                      hide-details

                      v-model="form.name"
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Kode" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div 
                      class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kode
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      :color="set_color"
                      placeholder="Contoh. 001"

                      hide-details

                      v-model="form.code"
                      :success="form.code !== '' && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                      class="py-0">
                      <div>
                        <div 
                          class="body-2 mb-2">
                          Jam Presensi Datang
                        </div>

                        <v-menu
                          ref="start_time"
                          v-model="time.start"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="form.presensi_start_time"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider 
                              name="Jam Presensi Datang" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save"

                                readonly
                                filled
                                rounded
                                dense

                                :color="set_color"
                                placeholder="Contoh. 08:00"

                                hide-details

                                clearable
                                @click:clear="form.presensi_start_time = ''; form.presensi_end_time = '';"
                                v-on="on"
                                v-bind="attrs"

                                v-model="form.presensi_start_time"
                                :success="form.presensi_start_time !== '' && form.presensi_start_time !== null && valid"
                                :error-messages="errors"
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="form.presensi_start_time !== '' && form.presensi_start_time !== null && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>

                          <v-time-picker
                            v-if="time.start"
                            v-model="form.presensi_start_time"
                            full-width
                            :color="set_color"
                            format="24hr"
                            @click:minute="$refs.start_time.save(`${form.presensi_start_time}`); form.presensi_end_time = '';">
                          </v-time-picker>
                        </v-menu>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="py-0">
                      <div>
                        <div 
                          class="body-2 mb-2">
                          Jam Presensi Pulang 
                        </div>
                        
                        <v-menu
                          ref="end_time"
                          v-model="time.end"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="form.presensi_end_time"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider 
                              name="Jam Presensi Pulang" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save"

                                readonly
                                filled
                                rounded
                                dense

                                :color="set_color"
                                placeholder="Contoh. 17:00"
                                
                                hide-details

                                clearable
                                @click:clear="form.presensi_end_time = ''"
                                v-on="on"
                                v-bind="attrs"

                                v-model="form.presensi_end_time"
                                :success="form.presensi_end_time !== '' && form.presensi_end_time !== null && valid"
                                :error-messages="errors"
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="form.presensi_end_time !== '' && form.presensi_end_time !== null && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>

                          <v-time-picker
                            v-if="time.end"
                            :min="form.presensi_start_time"
                            v-model="form.presensi_end_time"
                            full-width
                            :color="set_color"
                            format="24hr"
                            @click:minute="$refs.end_time.save(`${form.presensi_end_time}`)">
                          </v-time-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>

                  <div
                    class="mb-6">
                    <div 
                      class="body-2 mb-2">
                      Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                    </div>

                    <gmap-map
                      :center="center"
                      :zoom="12"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      }"
                      :clickable="true"
                      @click="updatePlace"
                      style="width: 100%; height: 500px;">

                      <gmap-marker
                        :position="center"
                        :draggable="true"
                        @drag="updatePlace"
                        @click="center=center">
                      </gmap-marker>
                    </gmap-map>
                  </div>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                      class="py-0">
                      <ValidationProvider 
                        name="Latitude" 
                        v-slot="{ errors, valid }">
                        <div 
                          class="body-2 mb-2">
                          Latitude
                        </div>

                        <v-text-field
                          filled
                          rounded
                          dense

                          type="number"
                          :color="set_color"

                          placeholder="Contoh. -7.689743"
                          hide-details

                          v-model="form.latitude"
                          :success="form.latitude !== '' && valid"
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.latitude !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="py-0">
                      <ValidationProvider 
                        name="Longitude" 
                        v-slot="{ errors, valid }">
                        <div 
                          class="body-2 mb-2">
                          Longitude
                        </div>

                        <v-text-field
                          filled
                          rounded
                          dense

                          type="number"
                          :color="set_color"
                          placeholder="Contoh. 110.606819"

                          hide-details

                          v-model="form.longitude"
                          :success="form.longitude !== '' && valid"
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.longitude !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <ValidationProvider 
                    name="Range Jarak" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      Range Jarak
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      :color="set_color"
                      placeholder="Contoh. 50"

                      hide-details

                      suffix="Meter"

                      v-model="form.attended_range"
                      :success="form.attended_range !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.attended_range !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn 
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

              <v-card v-if="selected.node.children !== undefined && selected.node.children.length > 0"
                flat
                :color="set_color_rgb_soft"
                class="pa-4 pt-3 mt-4"
                style="border-radius: 10px; border: 2px dashed #e0e0e0;">
                <div
                  class="body-2 orange--text font-italic line-text-first">
                  Jika Anda menghapus data yang Anda pilih, maka sub data juga akan dihapus.
                </div>
              </v-card>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-center">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text"
                :disabled="process.delete"
                :loading="process.delete"
                @click="deletes()">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text"
                :disabled="process.delete"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.map"
          @keydown.esc="dialog.map = false"
          :fullscreen="dialog.fullscreen"
          width="1000"
          persistent
          scrollable>
          <v-card v-if="markers.length > 0"
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              {{ markers[0].name }}

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.map = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text
              class="mt-4 mb-2">
              <gmap-map
                ref="gmap"
                :center="center"
                :zoom="12"
                :scrollwheel="false"
                style="width:100%;"
                :style="!dialog.fullscreen ? 'height: calc(100vh - 300px);' : 'height: calc(100vh - 118px);'">

                <gmap-marker
                  v-for="(item, index) in markers"
                  :key="index"
                  :position="item.latlng"
                  :icon="item.icon">
                </gmap-marker>
              </gmap-map>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="humax"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Struktur Organisasi
                    </span>
                  </div>

                  <v-spacer />

                  <div v-if="list.length < 1"
                    class="mr-4">
                    <v-btn
                      @click="dialog.form = true; reset();"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>

                  <div
                    class="d-flex align-center justify-end">
                    <v-btn
                      @click="zoomIn"
                      color="#4B4B4B"
                      fab
                      width="36"
                      height="36"
                      elevation="0"
                      style="border-radius: 10px 0px 0px 10px; border-right: 1px solid #FFFFFF;">
                      <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                    </v-btn>

                    <v-btn
                      @click="zoomOut"
                      color="#4B4B4B"
                      fab
                      width="36"
                      height="36"
                      elevation="0"
                      style="border-radius: 0px 10px 10px 0px; border-left: 1px solid #FFFFFF;">
                      <v-icon color="white">mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="3">
              <v-btn
                to="/unit/structure/regulation"
                color="#E5E7EB"
                elevation="0"
                class="text-capitalize d-flex align-center"
                style="border: 1px solid #374151; border-radius: 10px; width: 250px;">
                <!-- <v-icon>mdi-vector-polyline-edit</v-icon>

                <span
                  class="ml-2">
                  Lihat Peraturan Perusahaan
                </span> -->

                Lihat Peraturan Perusahaan
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              md="9">
              <div
                class="d-flex align-center justify-end">
                <div
                  class="d-flex align-center justify-end">
                  <div>
                    <span>
                      Total Unit:
                    </span>

                    <span
                      class="font-weight-bold black--text">
                      {{ count.unit }}
                    </span>
                  </div>

                  <div
                    class="ml-4">
                    <span>
                      Total Pegawai:
                    </span>

                    <span
                      class="font-weight-bold black--text">
                      {{ count.user }}
                    </span>
                  </div>
                </div>

                <div
                  class="d-flex align-center justify-end ml-4">
                  <v-btn
                    @click="selected.view = 0; fetch();"
                    :color="selected.view < 1 ? set_color : '#e6e7eb'"
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    style="border-radius: 10px 0px 0px 10px; border-right: 1px solid #FFFFFF;">
                    <v-icon :color="selected.view < 1 ? 'white' : ''">mdi-file-tree</v-icon>
                  </v-btn>

                  <v-btn
                    @click="selected.view = 1; fetchData();"
                    :color="selected.view > 0 ? set_color : '#e6e7eb'"
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    style="border-radius: 0px 10px 10px 0px; border-left: 1px solid #FFFFFF;">
                    <v-icon :color="selected.view > 0 ? 'white' : ''">mdi-table</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="selected.view < 1"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; height: calc(100vh - 242px); overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <div 
                    id="tree"
                    @mousewheel="deltaZoom">
                    <vue-tree
                      ref="tree"
                      linkStyle="straight"
                      direction="vertical"
                      :dataset="list"
                      :config="{ nodeWidth: 450, nodeHeight: 100, levelHeight: 250 }"
                      :collapse-enabled="true"
                      style="width: 100%; height: calc(100vh - 278px);">
                      <template v-slot:node="{ node, collapsed }">
                        <v-card
                          flat
                          min-width="350"
                          :class="collapsed ? '' : ''"
                          style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px; border-radius: 10px;"
                          :style="`border: 2px dashed ${set_color};`">
                          <v-card-text
                            class="pa-3 py-1"
                            style="height: 90px;">
                            <v-list
                              dense
                              style="background: transparent;">
                              <v-list-item
                                class="px-3">
                                <v-list-item-avatar 
                                  class="mr-3 mt-2"
                                  size="40"
                                  color="#FFFFFF"
                                  style="border: 2px solid #FFFFFF;"
                                  :style="`box-shadow: rgba(${set_color_rgb_custom}, 0.17) 0px -23px 25px 0px inset, rgba(${set_color_rgb_custom}, 0.15) 0px -36px 30px 0px inset, rgba(${set_color_rgb_custom}, 0.1) 0px -79px 40px 0px inset, rgba(${set_color_rgb_custom}, 0.06) 0px 2px 1px, rgba(${set_color_rgb_custom}, 0.09) 0px 4px 2px, rgba(${set_color_rgb_custom}, 0.09) 0px 8px 4px, rgba(${set_color_rgb_custom}, 0.09) 0px 16px 8px, rgba(${set_color_rgb_custom}, 0.09) 0px 32px 16px;`">
                                  <span
                                    class="body-1 font-weight-bold white--text">
                                    {{ node.name | initial }}
                                  </span>
                                </v-list-item-avatar>

                                <v-list-item-content
                                  style="max-width: 250px;">
                                  <div
                                    class="body-2 font-weight-bold black--text three-line text-capitalize mb-1">
                                    {{ node.name }}
                                  </div>

                                  <div
                                    class="body-2 black--text"
                                    style="opacity: 60%;">
                                    Total Pegawai. {{ node.total_pegawai }}
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card-text>

                          <v-card-text
                            class="pa-0"
                            style="position: relative; bottom: -17px;">
                            <v-row
                              align="center"
                              justify="center">
                              <v-col
                                :cols="user.role !== 'viewer' ? 2 : 6"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :to="`/unit/structure/officer/${node.id}?name=${node.name}`"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      :style="user.role !== 'viewer' ? 'border-radius: 8px 0px 0px 8px;' : 'border-radius: 8px 0px 0px 8px;'">
                                      <v-icon small color="white">mdi-account-group-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Pegawai
                                  </span>
                                </v-tooltip>
                              </v-col>

                              <v-col
                                :cols="user.role !== 'viewer' ? 2 : 6"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toMap(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      :style="user.role !== 'viewer' ? 'border-radius: 0px;' : 'border-radius: 0px 8px 8px 0px;'"
                                      style="border-left: 1px solid #FFFFFF;">
                                      <v-icon small color="white">mdi-map-marker-circle</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Map
                                  </span>
                                </v-tooltip>
                              </v-col>

                              <v-col v-if="user.role !== 'viewer'"
                                cols="2"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toAdd(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      style="border-radius: 0px; border-left: 1px solid #FFFFFF;">
                                      <v-icon small color="white">mdi-plus-circle-multiple-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Tambah
                                  </span>
                                </v-tooltip>
                              </v-col>

                              <v-col v-if="user.role !== 'viewer'"
                                cols="2"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toEdit(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      style="border-radius: 0px; border-left: 1px solid #FFFFFF;">
                                      <v-icon small color="white">mdi-circle-edit-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Ubah
                                  </span>
                                </v-tooltip>
                              </v-col>

                              <v-col v-if="user.role !== 'viewer'"
                                cols="2"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toDelete(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #FFFFFF;">
                                      <v-icon small color="white">mdi-delete-circle-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Hapus
                                  </span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </template>
                    </vue-tree>
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="selected.view > 0"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="humax" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="humax" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="humax" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="dialog.form = true; reset(list[index]);"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              :color="set_color"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDeleteTable(value)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Hapus</span>
                        </v-tooltip>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetchData($event)" 
                  @reloadPage="fetchData($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import VueTree from "@ssthouse/vue-tree-chart";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          snackbar: false,
          fullscreen: false,
          freeze: false,
          hide: false,

          form: false,
          delete: false,

          map: false
        },

        selected: {
          node: {},
          delete: [],

          view: 0,

          row: [],
          freeze: []
        },

        parent_ids: {},

        markers: [],
        unit: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },

        count: {
          unit: 0,
          user: 0
        },

        form: {
          id: '',
          parent_id: '0',
          code: '',
          name: '',
          latitude: '',
          longitude: '',
          attended_range: '',
          presensi_start_time: '',
          presensi_end_time: ''
        },

        time: {
          start: false,
          end: false
        },

        process: {
          load: false,

          form: false,
          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      VueTree,
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetchData(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_custom () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `${r}, ${g}, ${b}`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+70}, ${g+91}, ${b+34})`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()

      this.fetchUser()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.count.unit = res.results.pagination.total_data

            if (res.results.data.length > 0) {
              this.parent_ids = res.results.data.reduce((one, two) => one.parent_id < two.parent_id ? one : two)
  
              if (Object.keys(this.parent_ids).length > 0) {
                this.list = this.changeData(res.results.data, this.parent_ids.parent_id)
              }
            }

          }
        })
      },

      changeData (data_array, parent_ids) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.parent_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        // let richMediaData = getChilds('0', data)
        let richMediaData = getChilds(parent_ids, data)


        return richMediaData
      },

      deltaZoom(event) {
        if (event.deltaY < 0) {
          this.$refs.tree.zoomIn()
        } else {
          this.$refs.tree.zoomOut()
        }
      },

      zoomIn () {
        this.$refs.tree.zoomIn()
      },
      zoomOut () {
        this.$refs.tree.zoomOut()
      },

      async fetchUnit () {
        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },

      async fetchUser () {
        await get('admin/user/data')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.count.user = res.results.pagination.total_data
          }
        })
      },

      getGeoLocation() {
        if (this.form.id === '') {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        } else {
          this.center = {
            lat: this.form.latitude,
            lng: this.form.longitude
          }
        }
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          parent_id: item !== undefined ? item.parent_id : '0',
          code: item !== undefined ? item.code : '',
          name: item !== undefined ? item.name : '',
          latitude: item !== undefined ? parseFloat(item.latitude) : '',
          longitude: item !== undefined ? parseFloat(item.longitude) : '',
          attended_range: item !== undefined ? item.attended_range : '',
          presensi_start_time: item !== undefined ? item.presensi_start_time : '',
          presensi_end_time: item !== undefined ? item.presensi_end_time : ''
        }

        this.time = {
          start: false,
          end: false
        }

        this.center = {
          lat: item !== undefined ? parseFloat(item.latitude) : -7.8032076, 
          lng: item !== undefined ? parseFloat(item.longitude) : 110.3573354
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) {
          this.fetchUnit()

          this.getGeoLocation()
        }
      },

      toAdd(node, event) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = true

        this.form = {
          id: '',
          parent_id: node.id,
          code: '',
          name: '',
          latitude: '',
          longitude: '',
          attended_range: '',
          presensi_start_time: '',
          presensi_end_time: ''
        }

        this.time = {
          start: false,
          end: false
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) {
          this.fetchUnit()

          this.getGeoLocation()
        }
      },
      toEdit(node, event) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.dialog.form = true

        this.form = {
          id: node.id,
          parent_id: node.parent_id,
          code: node.code,
          name: node.name,
          latitude: parseFloat(node.latitude),
          longitude: parseFloat(node.longitude),
          attended_range: node.attended_range,
          presensi_start_time: node.presensi_start_time,
          presensi_end_time: node.presensi_end_time
        }

        this.time = {
          start: false,
          end: false
        }

        this.center = {
          lat: parseFloat(node.latitude), 
          lng: parseFloat(node.longitude)
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) {
          this.fetchUnit()

          this.getGeoLocation()
        }
      },
      toMap(node, event) {
        this.markers = []

        this.dialog.map = true

        this.$gmapApiPromiseLazy().then(() => {
          this.markers.push({
            id: node.id,
            name: node.name,
            latlng: {
              lat: parseFloat(node.latitude), 
              lng: parseFloat(node.longitude)
            },
            icon: {
              url: require('@/assets/icon/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[0].latlng : this.center
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/unit/add' : 'admin/unit/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              if (this.selected.view < 1) {
                this.fetch()
              } else {
                this.fetchData()
              }
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete(node, event) {
        this.selected.delete = []

        this.selected.node = node

        this.selected.delete.push(parseInt(node.id))

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/unit/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false

            this.selected.node = {}
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            if (this.selected.view < 1) {
                this.fetch()
              } else {
                this.fetchData()
              }
          } else {
            this.message.error = res.message
          }
        })
      },


      
      // VIEW TABLE
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = parseInt(value) + '%'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetchData (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get(`admin/unit/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '110px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Kode',
                width: '150px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama',
                width: '400px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Jam Presensi Datang',
                width: '200px',
                value: 'presensi_start_time',
                freeze: false,
                hide: false
              },
              {
                text: 'Jam Presensi Pulang',
                width: '200px',
                value: 'presensi_end_time',
                freeze: false,
                hide: false
              },
              {
                text: 'Latitude',
                width: '200px',
                value: 'latitude',
                freeze: false,
                hide: false
              },
              {
                text: 'Longitude',
                width: '200px',
                value: 'longitude',
                freeze: false,
                hide: false
              },
              {
                text: 'Range',
                width: '150px',
                value: 'attended_range',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Pegawai',
                width: '150px',
                value: 'total_pegawai',
                freeze: false,
                hide: false
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      toDeleteTable (id) {
        console.log(id)
        this.selected.delete = [id]

        this.dialog.delete = true
      }
    }
  }
</script>